import Axios from 'axios';
import config from '../config';

export const refreshToken = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  return Axios.post(config.apiBaseUrl + 'refresh-token', undefined, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      const refreshedToken = response.data.access_token;

      localStorage.setItem('accessToken', refreshedToken);
    })
    .catch(() => {
      localStorage.removeItem('accessToken');
    });
};
